import pmForecastService from '@/services/pmForecastService';

export default {
  namespaced: true,

  state: {
    projectId: null,
    data: null,
    loading: false,
    error: null,
  },

  getters: {
    projectId: (state) => state.projectId,
    loading: (state) => state.loading,
    error: (state) => state.error,
    forecastData: (state) => state.data,
    hasData: (state) => Boolean(state.data && !state.data.insufficientData),
    isInsufficientData: (state) => Boolean(state.data?.insufficientData),
    riskScore: (state) => state.data?.riskScore ?? null,
    riskLevel: (state) => state.data?.riskLevel ?? null,
    narrativeKey: (state) => state.data?.narrativeKey ?? null,
    criticalMilestone: (state) => state.data?.criticalMilestone ?? null,
    contributors: (state) => state.data?.contributors ?? [],
    signals: (state) => state.data?.signals ?? null,
    isPrognosis: (state) => state.data?.isPrognosis === true,
  },

  mutations: {
    SET_PROJECT_ID(state, projectId) {
      state.projectId = projectId;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_DATA(state, data) {
      state.data = data;
    },
    RESET(state) {
      state.projectId = null;
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },

  actions: {
    async fetchForecast({ commit, state }, projectId = state.projectId) {
      if (!projectId) {
        commit('RESET');
        return null;
      }

      commit('SET_PROJECT_ID', projectId);
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const data = await pmForecastService.getProjectForecast(projectId);
        commit('SET_DATA', data);
        return data;
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Failed to load forecast');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
